import { format } from "fecha";
import { saveAs } from "file-saver";

import type { CreateFlatsParams } from "../../../api/flats/create";
import { createFlats } from "../../../api/flats/create";
import { assertInstanceOf } from "../../../utils/assertinstanceof";
import { checkIn, checkOut } from "../../../utils/blocker";

/**
 * フラットファイル検索→ダウンロードエリア
 */
export class DownloadArea {
    /** ダウンロードボタン要素 */
    #elem: HTMLButtonElement;
    /** フラットファイル作成のパラメーター */
    #params: Partial<CreateFlatsParams> | { invalid: string };

    /**
     * コンストラクター。
     *
     * @param elem ダウンロードボタン要素
     */
    constructor(elem: HTMLElement) {
        assertInstanceOf(elem, HTMLButtonElement);
        this.#elem = elem;
        this.#params = {};
    }

    /**
     * 初期化処理を行う。
     * ダウンロードボタンのクリックイベントリスナーを設定する。
     */
    async init() {
        this.#elem.addEventListener("click", async () => {
            const params = this.#params;

            if ("invalid" in params) {
                alert(`${params.invalid}の値が正しく入力されていません。`);
                return;
            }

            try {
                checkIn("フラットファイルを作成しています。");

                for await (const current of createFlats(params)) {
                    const status = current.status;
                    console.log(status);

                    switch (status) {
                        case "succeeded": {
                            const zipPath = current.zipPath;
                            const fileName = `jsmdp_flatfile-${format(new Date(), "YYYYMMDD_HHmmss")}.zip`;

                            saveAs(zipPath, fileName);
                            break;
                        }

                        case "no_data": {
                            alert("指定された条件に該当するデータがありませんでした。");
                            break;
                        }

                        case "failed": {
                            alert("フラットファイルの作成中に問題が発生しました。");
                            break;
                        }

                        case "not_found": {
                            alert("フラットファイルが見つかりません。");
                            break;
                        }

                        // No default
                    }
                }
            } finally {
                checkOut();
            }
        });
    }

    /**
     * フラットファイル作成のパラメーターを設定する。
     *
     * @param params フラットファイル作成パラメーター
     */
    setParams(params: Partial<CreateFlatsParams> | { invalid: string }) {
        this.#params = params;
        this.#elem.disabled = ("invalid" in params);
    }
}
